import * as stylex from "@stylexjs/stylex";
import { colors } from "@softmax/design-system/tokens.stylex";
import type { ReactNode } from "react";

type SidebarIconName =
  | "browse"
  | "watch"
  | "play"
  | "policies"
  | "forum"
  | "wiki"
  | "docs"
  | "external";

const icons: Record<SidebarIconName, ReactNode> = {
  external: (
    <>
      <path d="M7 3.5H3.5v9h9V9" />
      <path d="M9.5 3h3.5v3.5M13 3 7.5 8.5" />
    </>
  ),
  browse: (
    <>
      <rect x="2.5" y="2.5" width="5" height="5" rx="1" />
      <rect x="8.5" y="2.5" width="5" height="5" rx="1" />
      <rect x="2.5" y="8.5" width="5" height="5" rx="1" />
      <rect x="8.5" y="8.5" width="5" height="5" rx="1" />
    </>
  ),
  watch: <path d="M5.5 3.2 12.3 8l-6.8 4.8V3.2Z" />,
  play: <path d="M5.5 3.2 12.3 8l-6.8 4.8V3.2Z" />,
  policies: (
    <>
      <circle cx="8" cy="5" r="2.5" />
      <path d="M3 13v-1a5 5 0 0 1 10 0v1" />
    </>
  ),
  forum: (
    <>
      <rect x="2.5" y="3" width="11" height="8" rx="1.5" />
      <path d="M5.5 11v2.4L8.4 11" />
    </>
  ),
  wiki: (
    <>
      <path d="M8 4.3S6.6 3.1 3 3.1v9c3.6 0 5 1.2 5 1.2s1.4-1.2 5-1.2v-9c-3.6 0-5 1.2-5 1.2Z" />
      <path d="M8 4.3v9" />
    </>
  ),
  docs: (
    <>
      <path d="M8 4.3S6.6 3.1 3 3.1v9c3.6 0 5 1.2 5 1.2s1.4-1.2 5-1.2v-9c-3.6 0-5 1.2-5 1.2Z" />
      <path d="M8 4.3v9" />
    </>
  ),
};

export function SidebarIcon({
  name,
  active = false,
}: {
  readonly name: SidebarIconName;
  readonly active?: boolean;
}) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...stylex.props(styles.icon, active && styles.activeIcon)}
    >
      {icons[name]}
    </svg>
  );
}

const styles = stylex.create({
  icon: { flexShrink: 0, color: colors.muted },
  activeIcon: { color: colors.foreground },
});
